<template>
  <div>
    <v-toolbar
      color="blue"
      dark
      tabs
    >

      <v-toolbar-title>Ingana</v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
  export default {
    name: "NavBar",
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue